module.exports = __webpack_public_path__ + "static/img/agility.0087ccb9.svg";